import { Controller } from "@hotwired/stimulus";
import closeCollapse from "../utils/closeCollapse";
import openCollapse from "../utils/openCollapse";

export default class extends Controller<HTMLElement> {
  static targets = ["collapsible", "collapsibleHeader"];

  declare readonly collapsibleTarget: HTMLDivElement;
  declare readonly collapsibleTargets: HTMLDivElement[];
  declare readonly collapsibleHeaderTarget: HTMLDivElement;

  toggle({ currentTarget: button }) {
    const {
      dataset: { target }
    } = button;

    // Collapse
    this.collapsibleTargets.forEach((collapse) => {
      if (collapse.getAttribute("id") === target) {
        if (collapse.classList.contains("open")) {
          closeCollapse(collapse);
        } else {
          openCollapse(collapse);
        }
      }
    });
  }
}
